import React, { Component } from 'react';
import { connect } from 'react-redux';

import { initModal, pushModal } from 'shared/actions/modal.action';

import Dim from 'web/components/common/modal/common/Dim';
import Logo from 'web/components/common/modal/common/Logo';

import { logout } from 'shared/actions/auth.action';
import storage from 'shared/utils/storage';

@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  {
    initModal,
    pushModal,
    logout,
  },
)
class GoToRealclass extends Component {
  componentDidMount() {}

  componentWillUnmount() {}

  close = () => {
    if (this.check.checked) {
      storage.set('no-more-modal', +new Date());
    }
    this.props.popupHandler.close();
  };

  render() {
    return (
      <Dim onClick={this.close}>
        <div
          className="modal"
          style={{
            position: 'relative',
            width: '320px',
            padding: '120px 30px 30px',
            backgroundColor: '#fff',
            color: '#000',
            borderRadius: '10px',
            overflow: 'hidden',
            textAlign: 'center',
            fontSize: '14px',
            lineHeight: '1.4',
          }}
        >
          <Logo />
          <h3
            style={{
              position: 'absolute',
              top: 75,
              left: 0,
              fontSize: 18,
              fontWeight: 600,
              width: '100%',
              textAlign: 'center',
            }}
          >
            닥터뮤지 가입/구매 안내
          </h3>
          <div style={{ height: 370, textAlign: 'left' }}>
            <p style={{ marginBottom: 20 }}>
              2020년 12월 17일 자로 서비스가 통합되어
              <br /> 닥터뮤지의 모든 학습 콘텐츠는 <b>리얼클래스</b>에서
              구매하실 수 있습니다. 닥터뮤지에 가입, 이용권 구매를 원하시는
              분들은 리얼클래스를 이용해주시기 바랍니다.
            </p>
            <p style={{ marginBottom: 20 }}>
              이전 닥터뮤지에서 이용권을 구매하신 회원 분들께서는 기존과
              동일하게 닥터뮤지 앱과 웹에서 학습과 환급 프로그램을 정상적으로
              이용하실 수 있습니다.
            </p>
            <p style={{ marginBottom: 20 }}>
              앞으로도 학습자 분들께 더 좋은 학습경험을 전달드리기 위해 최선의
              노력을 다하겠습니다. 추가로 궁금하신 점은 고객센터로 문의주시면
              친절하게 안내드겠습니다. <br />
              감사합니다.
            </p>
            <p style={{ marginBottom: 20 }}>닥터뮤지 드림</p>
          </div>
          <label>
            <input
              ref={input => (this.check = input)}
              type="checkbox"
              style={{ verticalAlign: 'text-top' }}
              onChange={this.close}
            />
            다시 보지 않기
          </label>
        </div>
      </Dim>
    );
  }
}

export default GoToRealclass;
